import { Link } from 'devextreme-react/sankey';
import { ToastBottomEnd } from "../../components/Toast";
import React, { useEffect, useState, useMemo, useRef } from 'react'
import { verifyTokenExpire } from "../../../middleware/verifyToken";
import { useTranslation } from 'react-i18next';
import ls from "localstorage-slim";
import appConfig from '../../../config/appConfig'
import { toastErrorMessageWithParameterConfig } from '../../../config/toastConfig';
import useSWR from 'swr';
import axios from 'axios';
import { AUTH_TOKEN } from '../../../constants/token';
import ListDiscussionBlock from './ListDiscussionBlock'
import MessageList from './MessageList'
import NoDiscussionSelected from './NoDiscussionSelected'
import EmptyMessage from './EmptyMessage'
import { now } from 'moment';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import EmptyDiscussion from './EmptyDiscussion';
import ChatLoader from './ChatLoader';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import SocialMediaFilters from './SocialMediaFilters';
import moment from 'moment';
import { map } from 'jquery';
import { localize } from "../../../helpers/function";

const SocialMedia = () => {
    //usage of useTranslation i18n
    const { t, ready } = useTranslation();

    const defaultData = {
        text: "",
        files: [],
        parent_id: "",
    };

    const defaultError = {
        text: "",
        files: [],
        parent_id: "",
    };

    const [data, setData] = useState(defaultData);
    const [load, setLoad] = useState(true);
    const [loadButton, setLoadButton] = useState(false);
    const [search, setSearch] = useState(false);
    const [listChat, setListChat] = useState([]);
    const [allChats, setAllChats] = useState([]); // Liste complète non filtrée
    const [activeChat, setActiveChat] = useState(null);
    const [listChatMessages, setListChatMessage] = useState([]);
    const [idChat, setIdChat] = useState(null);
    const [filters, setFilters] = useState({
        dateFrom: '',
        dateTo: '',
        senderName: '',
        myCharge: false,
        notTaken: false,
        takenByOthers: false,
        takenByUser: null,
        unread: false,
        read: false
    });
    // Etats pour la pagination des discussions
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    // Taille "théorique" d'une page côté backend (per_page renvoyé par l'API)
    const [pageSize, setPageSize] = useState(null);

    // Référence pour scroller automatiquement en bas de la liste des messages
    const messagesEndRef = useRef(null);
    const [shouldAutoScroll, setShouldAutoScroll] = useState(false);
    const autoOpenedDiscussionRef = useRef(null);

    const scrollToBottom = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
            });
        }
    };

    const changeChat = (id) => {
        // Récupérer la discussion cliquée
        const currentChat = allChats.find(chat => chat.id === id);

        if (!currentChat) {
            return;
        }

        // On exige qu'il y ait un responsable ET que ce soit l'utilisateur courant
        const respId = currentChat.responsable_id
            ? currentChat.responsable_id
            : (
                currentChat.responsable
                    ? (typeof currentChat.responsable === 'object'
                        ? currentChat.responsable.id
                        : currentChat.responsable)
                    : null
            );

        if(!currentUserRoles?.includes('pilot-filial')) {
            // Pas de responsable : personne ne peut consulter les messages
            if (!respId) {
                ToastBottomEnd.fire(
                    toastErrorMessageWithParameterConfig(
                        "Prenez en charge cette discussion pour la consulter."
                    )
                );
                return;
            }

            // Responsable différent de l'utilisateur courant : accès interdit
            if (!currentUserId || respId !== currentUserId) {
                ToastBottomEnd.fire(
                    toastErrorMessageWithParameterConfig(
                        "Vous n'êtes pas en charge de cette discussion."
                    )
                );
                return;
            }
        }

        // À partir d'ici, seul le responsable peut ouvrir et marquer en lu
        setActiveChat(id);
        setIdChat(id);
        setShouldAutoScroll(true);

        const alreadyRead = currentChat && currentChat.is_read;

        // Met à jour immédiatement l'état local pour marquer la discussion comme lue
        setListChat((prevChats) =>
            prevChats.map((chat) =>
                chat.id === id ? { ...chat, is_read: true } : chat
            )
        );
        setAllChats((prevChats) =>
            prevChats.map((chat) =>
                chat.id === id ? { ...chat, is_read: true } : chat
            )
        );

        // Appel API seulement si la discussion n'était pas encore lue
        if (!alreadyRead && currentUserId===respId) {
            axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
            if (verifyTokenExpire()) {
                axios
                    .put(
                        appConfig.apiDomaine + `/social-network/discussions/${id}/read/1`
                    )
                    .catch((error) => {
                        console.log('Erreur lors du marquage en lu de la discussion :', error)
                    });
            }
        }
    }


    const onChangeText = (e) => {
        let newData = { ...data };
        newData.text = e.target.value;
        setData(newData);
    };

    const addItem = (e) => {
        e.preventDefault();
        axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        
        if ((data.text !== "" && idChat)) {
            setLoadButton(true)
            if (verifyTokenExpire()) {
                axios
                .put(
                    appConfig.apiDomaine + `/social-network/discussions/${idChat}`,
                    {
                        message: data.text
                    }
                )
                .then((response) => {
                    listChat.map((chat) => {
                        if(chat.id==idChat) chat.messages.push({
                            type: 'out',
                            message: data.text,
                            created_at: now()
                        })
                    })
                    // Met à jour la liste des messages affichés en les triant par date
                    setListChatMessage(prevMessages => 
                        sortMessagesByDate([
                            ...prevMessages,
                            {
                                type: 'out',
                                message: data.text,
                                created_at: now()
                            }
                        ])
                    );
                    setIdChat(idChat);
                    setShouldAutoScroll(true);
                })
                .catch((error) => {
                    console.log(error)
                })
                .finally(() => {
                    setLoadButton(false)
                    setData(defaultData)
                });
                
            }
        }
    };

    const onChangeFile = (e) => {
        let newData = { ...data };
        newData.files = Object.values(e.target.files);
        setData(newData);
    };

    const responseToMessage = (id, text) => {
        const newData = { ...data };
        newData.parent_id = id;
        //setMessageTarget(text);
        setData(newData);
    };

    const closeTag = () => {
        const newData = { ...data };
        newData.parent_id = "";
        newData.files = "";
        //setMessageTarget("");
        setData(newData);
    };

    // Trier les messages d'une discussion par date de création (du plus ancien au plus récent)
    const sortMessagesByDate = (messages = []) => {
        return [...messages].sort((a, b) => {
            const dateA = a.created_at ? moment(a.created_at) : moment(0);
            const dateB = b.created_at ? moment(b.created_at) : moment(0);
            if (dateA.isBefore(dateB)) return -1;
            if (dateA.isAfter(dateB)) return 1;
            return 0;
        });
    };

    // Construit la query string pour les filtres à envoyer au backend
    // perPage est optionnel et permet d'ajuster dynamiquement la taille de page (paramètre "size")
    const buildDiscussionQueryString = (channel, pageToLoad = 1, perPage = null) => {
        const params = {
            channel,
            page: pageToLoad,
        };

        // Dates (format attendu: YYYY-MM-DD)
        if (filters.dateFrom) {
            params.date_from = filters.dateFrom;
        }
        if (filters.dateTo) {
            params.date_to = filters.dateTo;
        }

        // Nom de l'expéditeur (recherche texte)
        if (filters.senderName) {
            params.sender_name = filters.senderName;
        }

        // Statut de prise en charge
        if (filters.myCharge && currentUserId) {
            // Discussions à ma charge
            params.responsable_id = currentUserId;
        } else if (filters.takenByOthers) {
            // Discussions prises en charge par d'autres
            if (filters.takenByUser) {
                // Filtrage par responsable précis
                params.responsable_id = filters.takenByUser;
            } else if (currentUserId) {
                // Toutes les discussions prises en charge sauf moi
                params.responsable_not_id = currentUserId;
            }
        }

        if (filters.notTaken) {
            // Discussions sans responsable
            params.without_responsable = 1;
        }

        // Statut de lecture
        if (filters.unread && !filters.read) {
            params.is_read = 0; // Non lues
        } else if (filters.read && !filters.unread) {
            params.is_read = 1; // Lues
        }

        // Pagination : si perPage est fourni, on le passe en "size"
        // Cela permet, par exemple, au rafraîchissement SWR de récupérer
        // toutes les discussions déjà chargées.
        if (perPage && perPage > 0) {
            params.size = perPage;
        }

        return new URLSearchParams(params).toString();
    };

    const loadDiscussion = (channel, pageToLoad = 1) => {
        const channelAutoriser = ['whatsapp','facebook','twitter','linkedin']

        if(channelAutoriser.includes(channel)) {
            if(channel=="facebook") channel="messenger"
        }

        // Si on charge la première page, on active le loader global
        if (pageToLoad === 1) {
            setLoad(true);
            setAllChats([]);
            setListChat([]);
        } else {
            setLoadingMore(true);
        }
        
        axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        if(verifyTokenExpire()) {
            const queryString = buildDiscussionQueryString(channel, pageToLoad);
            axios
                .get(
                    appConfig.apiDomaine + `/social-network/discussions?${queryString}`
                )
                .then((response) => {
                    let newChats = [];
                    let nextHasMore = false;
                    let detectedPageSize = null;

                    // Nouveau format: { discussions: { data: [...], current_page, last_page, ... }, staffs: [...] }
                    const discussionsPayload = response.data && response.data.discussions
                        ? response.data.discussions
                        : response.data;

                    if (Array.isArray(discussionsPayload)) {
                        // Ancien format: tableau simple
                        newChats = discussionsPayload;
                        nextHasMore = false;
                    } else if (discussionsPayload && Array.isArray(discussionsPayload.data)) {
                        // Format paginé: { data: [...], current_page, last_page, next_page_url, ... }
                        newChats = discussionsPayload.data;
                        // Récupérer la taille réelle de page renvoyée par l'API
                        if (typeof discussionsPayload.per_page === 'number') {
                            detectedPageSize = discussionsPayload.per_page;
                        } else if (Array.isArray(discussionsPayload.data)) {
                            detectedPageSize = discussionsPayload.data.length;
                        }
                        if (typeof discussionsPayload.current_page === 'number' && typeof discussionsPayload.last_page === 'number') {
                            nextHasMore = discussionsPayload.current_page < discussionsPayload.last_page;
                        } else if (discussionsPayload.next_page_url !== undefined) {
                            nextHasMore = !!discussionsPayload.next_page_url;
                        } else {
                            nextHasMore = false;
                        }
                    }

                    // Mettre à jour la liste des staffs à partir du payload, si présent
                    if (response.data && Array.isArray(response.data.staffs)) {
                        const staffsList = response.data.staffs.map((staff) => ({
                            id: staff.id,
                            identite: staff.identite
                                ? `${staff.identite.firstname} ${staff.identite.lastname}`
                                : null
                        }));
                        setAllStaffs(staffsList);
                    }

                    if (detectedPageSize && detectedPageSize > 0) {
                        setPageSize(detectedPageSize);
                    }

                    if (newChats.length) {
                        if (pageToLoad === 1) {
                            setAllChats(newChats);
                            setListChat(newChats);
                        } else {
                            setAllChats((prev) => [...prev, ...newChats]);
                            setListChat((prev) => [...prev, ...newChats]);
                        }
                    } else if (pageToLoad === 1) {
                        setAllChats([]);
                        setListChat([]);
                        nextHasMore = false;
                    }

                    setPage(pageToLoad);
                    setHasMore(nextHasMore);
                    setLoad(false);
                    setLoadingMore(false);
                })
            .catch((error) => {
                setLoad(false);
                setLoadingMore(false);
            });
        }
    }

    const resetState = () => {
        setListChat([])
        setListChatMessage([])
        setIdChat(null)
        setActiveChat(null)
    }

    const {slug} = useParams()

    const reloadDiscussions = () => {
        setPage(1);
        setHasMore(true);
        setLoadingMore(false);
        loadDiscussion(slug, 1);
    }

    // Rafraîchissement "temps réel" des discussions (page 1) avec SWR
    const fetchDiscussionsRealtime = async () => {
        if (!slug) return null;

        let channel = slug;
        const channelAutoriser = ['whatsapp','facebook','twitter','linkedin'];
        if (channelAutoriser.includes(channel)) {
            if (channel === "facebook") channel = "messenger";
        }

        axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
        if (!verifyTokenExpire()) return null;

        // On veut que le SWR recharge toujours depuis la page 1,
        // mais avec une taille "size" qui correspond à toutes les pages
        // déjà chargées : size = pageCourante * pageSizeBackend.
        // Si on n'a pas encore de pageSize détecté, on essaie de l'inférer
        // à partir de la liste actuelle (listChat.length / page).
        let effectivePageSize = pageSize;
        if (!effectivePageSize && listChat.length > 0 && page > 0) {
            effectivePageSize = Math.round(listChat.length / page);
        }

        const perPage = effectivePageSize && page > 0
            ? effectivePageSize * page
            : null;

        const queryString = buildDiscussionQueryString(channel, 1, perPage);
        const response = await axios.get(
            appConfig.apiDomaine + `/social-network/discussions?${queryString}`
        );

        let newChats = [];
        let nextHasMore = false;

        // Nouveau format: { discussions: { data: [...], current_page, last_page, ... }, staffs: [...] }
        const discussionsPayload = response.data && response.data.discussions
            ? response.data.discussions
            : response.data;

        if (Array.isArray(discussionsPayload)) {
            newChats = discussionsPayload;
            nextHasMore = false;
        } else if (discussionsPayload && Array.isArray(discussionsPayload.data)) {
            newChats = discussionsPayload.data;
            if (typeof discussionsPayload.current_page === 'number' && typeof discussionsPayload.last_page === 'number') {
                nextHasMore = discussionsPayload.current_page < discussionsPayload.last_page;
            } else if (discussionsPayload.next_page_url !== undefined) {
                nextHasMore = !!discussionsPayload.next_page_url;
            } else {
                nextHasMore = false;
            }
        }

        // Mettre à jour la liste des staffs à partir du payload, si présent
        if (response.data && Array.isArray(response.data.staffs)) {
            const staffsList = response.data.staffs.map((staff) => ({
                id: staff.id,
                identite: staff.identite
                    ? `${staff.identite.firstname} ${staff.identite.lastname}`
                    : (staff.unit && staff.unit.name && localize(staff.unit.name))
                        ? localize(staff.unit.name)
                        : `Utilisateur ${staff.id}`,
            }));
            setAllStaffs(staffsList);
        }

        if (newChats.length) {
            // On remplace le contenu des pages déjà chargées
            // sans toucher au numéro de page courant (page),
            // pour que le calcul size = page * pageSize reste cohérent.
            setAllChats(newChats);
            setListChat(newChats);
        } else {
            setAllChats([]);
            setListChat([]);
            nextHasMore = false;
        }

        setHasMore(nextHasMore);

        return response.data;
    };

    // SWR pour le rafraîchissement "temps réel" des discussions.
    // On le désactive pendant les chargements manuels (load ou loadingMore)
    // afin d'éviter les conflits entre la pagination et le rafraîchissement.
    useSWR(
        slug && !load && !loadingMore
            ? ['social-discussions-realtime', slug, JSON.stringify(filters)]
            : null,
        fetchDiscussionsRealtime,
        {
            refreshInterval: 3000,
            revalidateOnFocus: true,
        }
    );

    // Chargement des pages suivantes
    const loadMoreDiscussions = () => {
        if (!hasMore || loadingMore || load) return;
        const nextPage = page + 1;
        loadDiscussion(slug, nextPage);
    };

    // Recharger depuis le backend quand les filtres changent
    useEffect(() => {
        // Ne pas lancer tant que le slug n'est pas connu
        if (!slug) return;
        setPage(1);
        setHasMore(true);
        setLoadingMore(false);
        loadDiscussion(slug, 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    useEffect(()=>{
        loadDiscussion(slug, 1)
    }, [])

    useEffect(() => {
        if (idChat != null) {
            const currentChat = listChat.find((chat) => chat.id === idChat);
            if (currentChat) {
                const baseSenderName = currentChat.identite ? currentChat.identite.fullName : currentChat.external_client_id;
                const sortedMessages = sortMessagesByDate(currentChat.messages || []).map(message => ({
                    ...message,
                    senderName: baseSenderName
                }));
                setListChatMessage(sortedMessages);
            }
        }
    }, [idChat, listChat]);

    // Scroll automatique uniquement à l'ouverture d'une discussion
    // ou après l'envoi d'un nouveau message.
    useEffect(() => {
        if (shouldAutoScroll && idChat && listChatMessages.length) {
            scrollToBottom();
            setShouldAutoScroll(false);
        }
    }, [shouldAutoScroll, idChat, listChatMessages]);

    const location = useLocation()

    useEffect(()=>{
        const channel = location.pathname.split('/').at(-1)
        setPage(1);
        setHasMore(true);
        setLoadingMore(false);
        loadDiscussion(channel, 1)
        resetState()
        autoOpenedDiscussionRef.current = null;
    }, [location.pathname])

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const discussionIdParam = queryParams.get('discussionId');

        if (!discussionIdParam || !listChat.length) return;

        const parsedDiscussionId = Number(discussionIdParam);
        if (!parsedDiscussionId || autoOpenedDiscussionRef.current === parsedDiscussionId) return;

        const targetDiscussion = listChat.find((chat) => chat.id === parsedDiscussionId);
        if (targetDiscussion) {
            autoOpenedDiscussionRef.current = parsedDiscussionId;
            changeChat(parsedDiscussionId);
            return;
        }

        const fallbackDiscussion = listChat.find((chat) => !chat.is_read) || listChat[0];
        if (!fallbackDiscussion || autoOpenedDiscussionRef.current === fallbackDiscussion.id) return;

        autoOpenedDiscussionRef.current = fallbackDiscussion.id;
        changeChat(fallbackDiscussion.id);
    }, [location.search, listChat]);

    const [currentUserId, setCurrentUserId] = useState(null);
    const [currentUserRoles, setCurrentUserRoles] = useState(null);
    const [allStaffs, setAllStaffs] = useState([]); // Tous les staffs de l'institution
    
    useEffect(() => {
        const userDataJson = JSON.parse(ls.get("userData"));
        if (userDataJson?.staff?.id) {
            setCurrentUserId(userDataJson.staff.id);
            setCurrentUserRoles(userDataJson.data.roles?.map(role => role.name) || []);
        }
    }, []);

    // Récupérer tous les staffs de l'institution (fallback si l'API /social-network/discussions
    // ne renvoie pas "staffs" ou si la liste est vide)
    useEffect(() => {
        if (allStaffs.length) return;
        if (verifyTokenExpire()) {
            axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
            // Essayer d'abord avec /my/staff, puis /any/staff si nécessaire
            axios
                .get(`${appConfig.apiDomaine}/my/staff?size=1000`)
                .then((response) => {
                    if (response.data && response.data.data) {
                        const staffsList = response.data.data.map(staff => ({
                            id: staff.id,
                            identite: staff.identite 
                                ? `${staff.identite.firstname} ${staff.identite.lastname}` 
                                : `Utilisateur ${staff.id}`
                        }));
                        setAllStaffs(staffsList);
                    }
                })
                .catch(() => {
                    // Si /my/staff échoue, essayer /any/staff
                    axios
                        .get(`${appConfig.apiDomaine}/any/staff?size=1000`)
                        .then((response) => {
                            if (response.data && response.data.data) {
                                const staffsList = response.data.data.map(staff => ({
                                    id: staff.id,
                                    identite: staff.identite 
                                        ? `${staff.identite.firstname} ${staff.identite.lastname}` 
                                        : `Utilisateur ${staff.id}`
                                }));
                                setAllStaffs(staffsList);
                            }
                        })
                        .catch((error) => {
                            console.error('Erreur lors de la récupération des staffs:', error);
                        });
                });
        }
    }, [allStaffs.length]);

    // Pour le filtre "Discussions prises en charge par d'autres", on veut utiliser
    // directement la liste des staffs renvoyée par l'API (`staffs` dans la payload)
    // afin que le select affiche exactement ces utilisateurs.
    const availableResponsables = useMemo(() => {
        return allStaffs;
    }, [allStaffs]);

    // Vérifie si l'utilisateur peut envoyer des messages dans la discussion active
    const canSendMessage = () => {
        // Si pas de discussion active, on ne peut pas envoyer
        if (!activeChat) return false;

        // Si l'utilisateur n'est pas un pilote, il peut envoyer (logique normale)
        if (!currentUserRoles?.includes('pilot-filial')) {
            return true;
        }

        // Si c'est un pilote, vérifier s'il a la discussion en charge
        const currentChat = allChats.find(chat => chat.id === activeChat);
        if (!currentChat) return false;

        const respId = currentChat.responsable_id
            ? currentChat.responsable_id
            : (
                currentChat.responsable
                    ? (typeof currentChat.responsable === 'object'
                        ? currentChat.responsable.id
                        : currentChat.responsable)
                    : null
            );

        // Le pilote peut envoyer seulement s'il est responsable
        return currentUserId && respId === currentUserId;
    };

    // Construit la liste des messages avec un séparateur de date avant chaque journée
    const renderMessagesWithDateHeaders = () => {
        const elements = [];
        let lastDateLabel = null;

        listChatMessages.forEach((message, index) => {
            const dateLabel = message.created_at
                ? moment(message.created_at).format('LL')
                : null;

            if (dateLabel && dateLabel !== lastDateLabel) {
                elements.push(
                    <div
                        key={`date-${dateLabel}-${index}`}
                        className="d-flex justify-content-center"
                        style={{ marginTop: '16px', marginBottom: '8px' }}
                    >
                        <span
                            className="badge badge-secondary"
                            style={{ padding: '6px 12px', fontSize: '11px' }}
                        >
                            {dateLabel}
                        </span>
                    </div>
                );
                lastDateLabel = dateLabel;
            }

            elements.push(
                <MessageList
                    key={index}
                    data={message}
                />
            );
        });

        return elements;
    };

    return (
        <div
            className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
            id="kt_content"
        >
            <div className="kt-subheader   kt-grid__item" id="kt_subheader">
                <div className="kt-container  kt-container--fluid ">
                    <div className="kt-subheader__main">
                        
                        <h3 className="kt-subheader__title"> {t("Discussion")} </h3>
                        <span className="kt-subheader__separator kt-hidden" />
                        <div className="kt-subheader__breadcrumbs">
                            <a href="#icone" className="kt-subheader__breadcrumbs-home">
                                <i className="flaticon2-shelter" />
                            </a>
                            <span className="kt-subheader__breadcrumbs-separator" />
                            <a
                                href="#button"
                                onClick={(e) => e.preventDefault()}
                                className="kt-subheader__breadcrumbs-link"
                            >
                                {t("reseau")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">
                    <div
                        className="kt-grid__item kt-app__toggle kt-app__aside kt-app__aside--lg kt-app__aside--fit"
                        id="kt_chat_aside"
                    >
                        <div className="kt-portlet kt-portlet--last">
                            <div className="kt-portlet__body">
                                {/*   FILTRES*/}
                                <SocialMediaFilters
                                    filters={filters}
                                    onFiltersChange={setFilters}
                                    currentUserId={currentUserId}
                                    availableResponsables={availableResponsables}
                                />
                                
                                {/*   RECHERCHE*/}
                                {/* <div className="kt-searchbar">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="24px"
                                                height="24px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                                className="kt-svg-icon"
                                                >
                                                <g
                                                    stroke="none"
                                                    strokeWidth="1"
                                                    fill="none"
                                                    fillRule="evenodd"
                                                >
                                                    <rect x="0" y="0" width="24" height="24"></rect>
                                                    <path
                                                    d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                                                    fill="#000000"
                                                    fillRule="nonzero"
                                                    opacity="0.3"
                                                    ></path>
                                                    <path
                                                    d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                                                    fill="#000000"
                                                    fillRule="nonzero"
                                                    ></path>
                                                </g>
                                                </svg>
                                            </span>
                                        </div>
                                        <input
                                            id="myInput"
                                            type="text"
                                            className="form-control"
                                            placeholder={t("Search")}
                                            aria-controls="basic-addon1"
                                        />
                                    </div>
                                </div> */}

                                <div className="kt-widget kt-widget--users">
                                    <div
                                        className="kt-scroll kt-scroll--pull ps--active-y"
                                        data-mobile-height="300"
                                        style={{ height: "400px", overflow: "scroll" }}
                                    >
                                        <ul id="myUL">
                                            {   load ? 
                                                    <ChatLoader />
                                                : 
                                                listChat.length ?
                                                    listChat.map((chat, i) => {
                                                    
                                                return <ListDiscussionBlock 
                                                    key={i} 
                                                    numero={chat.external_client_id}
                                                    sender={chat.identite ? chat.identite.fullName : null}
                                                    lastMessage={chat.messages && chat.messages.length ? chat.messages.at(-1).message : ''}
                                                    date={chat.messages && chat.messages.length ? chat.messages.at(-1).created_at : null}
                                                    id={chat.id}
                                                    activeChat={activeChat}
                                                    changeChat={changeChat}
                                                    isread={chat.is_read}
                                                    channel={slug}
                                                    responsable={chat.responsable}
                                                    responsableId={chat.responsable_id}
                                                    responsableIdentite={chat.responsable_identite}
                                                    currentUserId={currentUserId}
                                                    onReloadDiscussions={reloadDiscussions}
                                                />
                                                    })
                                                : <EmptyDiscussion />
                                            }
                                        </ul>
                                        {/* Bouton de chargement supplémentaire pour la pagination */}
                                        {!load && listChat.length > 0 && hasMore && (
                                            <div className="text-center my-3">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary btn-sm"
                                                    onClick={loadMoreDiscussions}
                                                    disabled={loadingMore}
                                                >
                                                    {loadingMore ? t("Chargement") + "..." : t("Charger plus de discussions")}
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="kt-grid__item kt-grid__item--fluid kt-app__content"
                        id="messageList"
                    >
                        <div className="kt-chat" id="kt-chat">
                            <div className="kt-portlet kt-portlet--head-lg- ">
                                <div className="kt-portlet__head">
                                    <div className="kt-chat__head ">
                                        <div className="kt-chat__left">
                                            <span></span>
                                        </div>
                                        <div className="kt-chat__center">
                                            <h5>{t("Discussions")}</h5>
                                        </div>
                                        <div className="kt-chat__right">
                                            <div className="dropdown dropdown-inline">
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-portlet__body">
                                    <div
                                        className="kt-scroll kt-scroll--pull ps ps--active-y overflow-auto"
                                        id="kt-scroll"
                                        data-mobile-height="350"
                                        style={{ height: "250px", overflow: "auto" }}
                                    >
                                        <div className="message-list">
                                            {idChat ? (
                                                listChatMessages.length ? (
                                                    <>
                                                        {renderMessagesWithDateHeaders()}
                                                        <div ref={messagesEndRef} />
                                                    </>
                                                ) : (
                                                    <EmptyMessage />
                                                )
                                            ) : (
                                                <NoDiscussionSelected />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="kt-portlet__foot position-relative">
                                    <div className="kt-chat__input">
                                        <input
                                            style={{ display: "none" }}
                                            id="parent_id"
                                            type="text"
                                            value={data.parent_id}
                                            onChange={responseToMessage}
                                        />

                                        <div className="kt-chat__editor">
                                        {data.parent_id ? (
                                            <div className="message_target">
                                                <i
                                                    className="d-flex justify-content-end flaticon-close"
                                                    onClick={(e) => closeTag(e)}
                                                ></i>
                                                <i className="la la-tags"></i>
                                                <br />
                                            </div>
                                        ) : (
                                            ""
                                        )}

                                        {/*data.files
                                            ? data.files.map((file, i) => (
                                                <div className="message_target" key={i}>
                                                <i
                                                    className="d-flex justify-content-end flaticon-close"
                                                    onClick={(e) => closeTag(e)}
                                                />
                                                <img
                                                    src="/assets/media/users/file-icon.png"
                                                    alt=""
                                                    style={{
                                                    maxWidth: "55px",
                                                    maxHeight: "55px",
                                                    }}
                                                />
                                                {file.name}
                                                </div>
                                            ))
                                            : ""*/}

                                            {
                                                activeChat && canSendMessage() && (
                                                    <textarea
                                                        id={"monChamp"}
                                                        style={{ height: "35px" }}
                                                        autoFocus={true}
                                                        placeholder={t("Votre message...")}
                                                        value={data.text}
                                                        onChange={(e) => onChangeText(e)}
                                                    />
                                                )
                                            }
                                        </div>
                                        <div className="kt-chat__toolbar">
                                            {/*<div className="image-upload">
                                                <label
                                                    htmlFor="file-input"
                                                    data-toggle="kt-tooltip"
                                                    title={t("Ajouter un fichier")}
                                                >
                                                    <i className="fas fa-paperclip"></i>
                                                </label>
                                                <input
                                                    id="file-input"
                                                    type="file"
                                                    onChange={onChangeFile}
                                                    multiple={true}
                                                />
                                            </div>*/}

                                            <div className="kt_chat__actions">
                                                
                                                {activeChat && canSendMessage() && !loadButton && (
                                                    <button
                                                        type="button"
                                                        onClick={(e) => addItem(e)}
                                                        className="btn btn-brand btn-md btn-upper btn-bold kt-chat__reply "
                                                    >
                                                        {t("Envoyer")}
                                                    </button>
                                                )}
                                                {activeChat && canSendMessage() && loadButton && (
                                                    <button
                                                        className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                                                        type="button"
                                                        disabled
                                                    >
                                                        {t("Chargement")}...
                                                    </button>
                                                )}
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SocialMedia